
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexyGRcOv_YKtJGtsEcC2wUAVBeSlpV35scVRQWUAQcoM0Meta } from "/var/lib/jenkins/workspace/Master/pages/admin/index.vue?macro=true";
import { default as loginBkqYVVT_459wxaatNjqTA_jnIPXQdNOpPBYOICLHn7KQQMeta } from "/var/lib/jenkins/workspace/Master/pages/admin/auth/login.vue?macro=true";
import { default as new_45N87mGoEgEB_4EYosVo4eSu9sT_455xmQIux_ERTnokT4Meta } from "/var/lib/jenkins/workspace/Master/pages/admin/colors/new.vue?macro=true";
import { default as newjb_45w1EykJ7B_45i0faGK7GHULbMl_WTtADLF9Qs_453gtrMMeta } from "/var/lib/jenkins/workspace/Master/pages/admin/themes/new.vue?macro=true";
import { default as _91id_93jvE6nD6twoTHUt6bSMKW_45dBanQJYB2NJWThhoI4OUI4Meta } from "/var/lib/jenkins/workspace/Master/pages/admin/colors/[id].vue?macro=true";
import { default as _91id_93t4_45uGIXE2fwAMpda4foGPQBdbO_45VQkcEKswpUJeWm_45gMeta } from "/var/lib/jenkins/workspace/Master/pages/admin/themes/[id].vue?macro=true";
import { default as indextUj6K4_Sni_dn8QCa4RwTW1WxlnM_Gtvd_45aLrHUpNi0Meta } from "/var/lib/jenkins/workspace/Master/pages/admin/colors/index.vue?macro=true";
import { default as newMJnoFCZLLxVGnFLNOXqw9jwrCrQf1RiEuxsz2j3L9J4Meta } from "/var/lib/jenkins/workspace/Master/pages/admin/products/new.vue?macro=true";
import { default as indexDE1fe_45IcfWyxDP0TB9hg3tP75otOpr9wHHXsevrV_yUMeta } from "/var/lib/jenkins/workspace/Master/pages/admin/themes/index.vue?macro=true";
import { default as indexkHmA9ty2P6nbWTWV0Myqj_tkQ9BLt0FMyderM86xLvkMeta } from "/var/lib/jenkins/workspace/Master/pages/admin/account/index.vue?macro=true";
import { default as newXHcCI9bNU_45qiBDAvNA3lFRnH5yAM8NqLwhN3IPodpIEMeta } from "/var/lib/jenkins/workspace/Master/pages/admin/locations/new.vue?macro=true";
import { default as _91id_93bCxAuA7v2Ui2R3EnKc_45vXudMoJjOMGytI47gLpe2JkIMeta } from "/var/lib/jenkins/workspace/Master/pages/admin/products/[id].vue?macro=true";
import { default as newnaTgm1jELjicbRSkcSgpIitZCA7spsP319ZLurqzMzAMeta } from "/var/lib/jenkins/workspace/Master/pages/admin/categories/new.vue?macro=true";
import { default as _91id_93Q6OesVyvd_45wXO1PP1V8K0ygzOZqOP52joNo53c0mQ6EMeta } from "/var/lib/jenkins/workspace/Master/pages/admin/locations/[id].vue?macro=true";
import { default as indexGKx4KBmOVUx0_T1pYWJdHgNU2LYPVM1_Zqr60J1z5wUMeta } from "/var/lib/jenkins/workspace/Master/pages/admin/products/index.vue?macro=true";
import { default as _91id_93wy9CaAJHavF0BCltmg5VBAFeuI1nbzSeWQW1Pbt3CrAMeta } from "/var/lib/jenkins/workspace/Master/pages/admin/categories/[id].vue?macro=true";
import { default as indexWYSa0tFEHJ9HSOiS5nifvBiMy_45H7wFOFAhONyUxnr_45UMeta } from "/var/lib/jenkins/workspace/Master/pages/admin/locations/index.vue?macro=true";
import { default as indexeAX4VxxNAwmqQPP_45Of6ifuhW6qheRiojtFCY1sWo85AMeta } from "/var/lib/jenkins/workspace/Master/pages/admin/categories/index.vue?macro=true";
import { default as adminYhj4z90UaWjZhYDKnUUqt5mh1JjbjKigQaXYsCj4HskMeta } from "/var/lib/jenkins/workspace/Master/pages/admin.vue?macro=true";
import { default as pers_45kit_45FRROmFXIXcWLNJaUxND5zS91pX0LEgP_sq2pvkGPEcMeta } from "/var/lib/jenkins/workspace/Master/pages/pers-kit.vue?macro=true";
import { default as _91_46_46_46slug_936_45aSBsaoS_45Rn_amSbfAZVIn3paBI_41IOj0Um_454b5ycMeta } from "/var/lib/jenkins/workspace/Master/pages/[...slug].vue?macro=true";
import { default as quotemakeryupjrw_ek4ionbz0E814_45Cp_M7cnv8PftnUEyhms8xIMeta } from "/var/lib/jenkins/workspace/Master/pages/quotemaker.vue?macro=true";
import { default as styleguide7ucIDV1cYlD4O0_xwyEMW9PsrVoxzxUjaxapWG21SjMMeta } from "/var/lib/jenkins/workspace/Master/pages/styleguide.vue?macro=true";
import { default as social_45mediaU877ixD285NBTUCHXTpckr6edh32wSaRhheDm8epBBwMeta } from "/var/lib/jenkins/workspace/Master/pages/social-media.vue?macro=true";
import { default as _91id_93q5auzQQd_45yUEpQxctcoK_45TV6SFlYZJMIBSCRAW162akMeta } from "/var/lib/jenkins/workspace/Master/pages/verhuur-nieuw/[id].vue?macro=true";
import { default as indexhRycxcRB129O3hTi0X9N_45wxE0PhVCDhqXJERFLtq3DsMeta } from "/var/lib/jenkins/workspace/Master/pages/verhuur-nieuw/index.vue?macro=true";
import { default as _91id_93nAsoiysvvVqx1W3Rbynl1TTQYDqqW85MUCYNhpmOEFYMeta } from "/var/lib/jenkins/workspace/Master/pages/verhuur-nieuw/product/[slug]/[id].vue?macro=true";
import { default as component_45stub7i7SpV4ZYoIMHkni8mJW8qdEX4mqVB7WAlWS9e2RIv8Meta } from "/var/lib/jenkins/workspace/Master/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stub7i7SpV4ZYoIMHkni8mJW8qdEX4mqVB7WAlWS9e2RIv8 } from "/var/lib/jenkins/workspace/Master/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: adminYhj4z90UaWjZhYDKnUUqt5mh1JjbjKigQaXYsCj4HskMeta?.name,
    path: "/admin",
    meta: adminYhj4z90UaWjZhYDKnUUqt5mh1JjbjKigQaXYsCj4HskMeta || {},
    component: () => import("/var/lib/jenkins/workspace/Master/pages/admin.vue"),
    children: [
  {
    name: "admin",
    path: "",
    component: () => import("/var/lib/jenkins/workspace/Master/pages/admin/index.vue")
  },
  {
    name: "admin-auth-login",
    path: "auth/login",
    meta: loginBkqYVVT_459wxaatNjqTA_jnIPXQdNOpPBYOICLHn7KQQMeta || {},
    component: () => import("/var/lib/jenkins/workspace/Master/pages/admin/auth/login.vue")
  },
  {
    name: "admin-colors-new",
    path: "colors/new",
    component: () => import("/var/lib/jenkins/workspace/Master/pages/admin/colors/new.vue")
  },
  {
    name: "admin-themes-new",
    path: "themes/new",
    component: () => import("/var/lib/jenkins/workspace/Master/pages/admin/themes/new.vue")
  },
  {
    name: "admin-colors-id",
    path: "colors/:id()",
    component: () => import("/var/lib/jenkins/workspace/Master/pages/admin/colors/[id].vue")
  },
  {
    name: "admin-themes-id",
    path: "themes/:id()",
    component: () => import("/var/lib/jenkins/workspace/Master/pages/admin/themes/[id].vue")
  },
  {
    name: "admin-colors",
    path: "colors",
    component: () => import("/var/lib/jenkins/workspace/Master/pages/admin/colors/index.vue")
  },
  {
    name: "admin-products-new",
    path: "products/new",
    component: () => import("/var/lib/jenkins/workspace/Master/pages/admin/products/new.vue")
  },
  {
    name: "admin-themes",
    path: "themes",
    component: () => import("/var/lib/jenkins/workspace/Master/pages/admin/themes/index.vue")
  },
  {
    name: "admin-account",
    path: "account",
    component: () => import("/var/lib/jenkins/workspace/Master/pages/admin/account/index.vue")
  },
  {
    name: "admin-locations-new",
    path: "locations/new",
    component: () => import("/var/lib/jenkins/workspace/Master/pages/admin/locations/new.vue")
  },
  {
    name: "admin-products-id",
    path: "products/:id()",
    component: () => import("/var/lib/jenkins/workspace/Master/pages/admin/products/[id].vue")
  },
  {
    name: "admin-categories-new",
    path: "categories/new",
    component: () => import("/var/lib/jenkins/workspace/Master/pages/admin/categories/new.vue")
  },
  {
    name: "admin-locations-id",
    path: "locations/:id()",
    component: () => import("/var/lib/jenkins/workspace/Master/pages/admin/locations/[id].vue")
  },
  {
    name: "admin-products",
    path: "products",
    component: () => import("/var/lib/jenkins/workspace/Master/pages/admin/products/index.vue")
  },
  {
    name: "admin-categories-id",
    path: "categories/:id()",
    component: () => import("/var/lib/jenkins/workspace/Master/pages/admin/categories/[id].vue")
  },
  {
    name: "admin-locations",
    path: "locations",
    component: () => import("/var/lib/jenkins/workspace/Master/pages/admin/locations/index.vue")
  },
  {
    name: "admin-categories",
    path: "categories",
    component: () => import("/var/lib/jenkins/workspace/Master/pages/admin/categories/index.vue")
  }
]
  },
  {
    name: "pers-kit",
    path: "/pers-kit",
    component: () => import("/var/lib/jenkins/workspace/Master/pages/pers-kit.vue")
  },
  {
    name: "slug",
    path: "/:slug(.*)*",
    component: () => import("/var/lib/jenkins/workspace/Master/pages/[...slug].vue")
  },
  {
    name: "quotemaker",
    path: "/quotemaker",
    component: () => import("/var/lib/jenkins/workspace/Master/pages/quotemaker.vue")
  },
  {
    name: "styleguide",
    path: "/styleguide",
    component: () => import("/var/lib/jenkins/workspace/Master/pages/styleguide.vue")
  },
  {
    name: "social-media",
    path: "/social-media",
    component: () => import("/var/lib/jenkins/workspace/Master/pages/social-media.vue")
  },
  {
    name: "verhuur-nieuw-id",
    path: "/verhuur-nieuw/:id()",
    component: () => import("/var/lib/jenkins/workspace/Master/pages/verhuur-nieuw/[id].vue")
  },
  {
    name: "verhuur-nieuw",
    path: "/verhuur-nieuw",
    component: () => import("/var/lib/jenkins/workspace/Master/pages/verhuur-nieuw/index.vue")
  },
  {
    name: "verhuur-nieuw-product-slug-id",
    path: "/verhuur-nieuw/product/:slug()/:id()",
    component: () => import("/var/lib/jenkins/workspace/Master/pages/verhuur-nieuw/product/[slug]/[id].vue")
  },
  {
    name: component_45stub7i7SpV4ZYoIMHkni8mJW8qdEX4mqVB7WAlWS9e2RIv8Meta?.name,
    path: "/verhuurfolder",
    component: component_45stub7i7SpV4ZYoIMHkni8mJW8qdEX4mqVB7WAlWS9e2RIv8
  },
  {
    name: component_45stub7i7SpV4ZYoIMHkni8mJW8qdEX4mqVB7WAlWS9e2RIv8Meta?.name,
    path: "/filmpjes",
    component: component_45stub7i7SpV4ZYoIMHkni8mJW8qdEX4mqVB7WAlWS9e2RIv8
  },
  {
    name: component_45stub7i7SpV4ZYoIMHkni8mJW8qdEX4mqVB7WAlWS9e2RIv8Meta?.name,
    path: "/sponsoren",
    component: component_45stub7i7SpV4ZYoIMHkni8mJW8qdEX4mqVB7WAlWS9e2RIv8
  },
  {
    name: component_45stub7i7SpV4ZYoIMHkni8mJW8qdEX4mqVB7WAlWS9e2RIv8Meta?.name,
    path: "/videos-2023",
    component: component_45stub7i7SpV4ZYoIMHkni8mJW8qdEX4mqVB7WAlWS9e2RIv8
  }
]